import React, { DragEvent } from "react";
import "./DragAndDropArea.css";

export interface DragAndDropAreaProps {
  onDragStart?: (event: DragEvent<HTMLDivElement>) => void;
  onDragOver?: (event: DragEvent<HTMLDivElement>) => void;
  onDragLeave?: (event: DragEvent<HTMLDivElement>) => void;
  onDrop?: (event: DragEvent<HTMLDivElement>) => void;
}

const DragAndDropArea = ({
  onDragLeave,
  onDragStart,
  onDragOver,
  onDrop,
}: DragAndDropAreaProps) => {
  return (
    <div
      className="drag-end-drop-area"
      onDragStart={onDragStart}
      onDragOver={onDragStart}
      onDragLeave={onDragLeave}
      onDrop={onDrop}
    />
  );
};

export default DragAndDropArea;
